import MessageBus from '../../ports-frontend/MessageBus';
import config from '../../config';
import Window from '../../ports-frontend/Window';

export async function openDeposit() {
  const kraken = await Window.getKraken();
  MessageBus.publishEvent({
    topic: 'wh.common.command.ui.header.deposit.open',
    data: {
      type: kraken?.quickDepositEnabled ? 'QUICK_DEPOSIT' : 'DEPOSIT',
    },
  });
}

export function hideBalance() {
  MessageBus.publishEvent({
    topic: 'wh.kraken.command.myaccount.balance.hide',
  });
}

export function showBalance() {
  MessageBus.publishEvent({
    topic: 'wh.kraken.command.myaccount.balance.show',
  });
}

function accountItemMap(
  type:
    | 'deposit'
    | 'responsibleGambling'
    | 'transactionHistory'
    | 'transferToPoker'
) {
  const map = {
    deposit: {
      topic: 'wh.common.event.ui.header.deposit.requested',
      data: {
        eventSource: 'Gaming',
      },
    },
    responsibleGambling: {
      topic: 'wh.myAccount.command.dropdown.open',
      data: {
        path: 'saferGambling',
      },
    },
    transactionHistory: {
      topic: 'wh.myAccount.command.dropdown.open',
      data: {
        path: 'accountHistory',
      },
    },
    transferToPoker: {
      topic: 'wh.myAccount.command.modals.open.pokerBalanceTransfer',
      data: {},
    },
  };

  return map[type];
}

export function openingAccountItemModal(
  accountAction:
    | 'deposit'
    | 'responsibleGambling'
    | 'transactionHistory'
    | 'transferToPoker'
) {
  const messageBusEvent = accountItemMap(accountAction);
  MessageBus.publishEvent(messageBusEvent);
}

export function accountWatcher({ callback }: { callback: Function }) {
  MessageBus.onSubscribe(
    data => {
      switch (data.message) {
        case 'wh.myAccount.event.viewPromotions':
          return callback({
            type: 'VIEW_PROMOTIONS_EVENT_CALLED',
            payload: {
              path: config.functionalities.promotions.path,
            },
          });
      }
    },
    ['wh.myAccount.event.viewPromotions']
  );
}
